import React, { FunctionComponent } from 'react';
import {
	Card,
	Tabs,
	TabsButtonGroup,
	TabsButton,
	TabsContent,
} from '@mlc/web-ui-toolkit';
import { PlanProfile as PlanProfileDomain } from '../../../../../logic/domains/planProfile.domain';
import NoMatching from '../Common/NoMatching';
import planProfileTestIds from '../PlanProfile.elements';
import PlanBalance from './PlanBalance';
import PlanDetails from './PlanDetails';
import MemberDemographics from './MemberDemographics';
import MemberBenefits from './MemberBenefits';
import PlanInvestments from './PlanInvestments/PlanInvestments';
import MemberTransactions from './MemberTransactions';
import { PlanProfileCard } from './styled';

type Props = {
	planUUID: string;
	planProfile: PlanProfileDomain;
};

const PlanProfileTabs: FunctionComponent<Props> = ({
	planUUID,
	planProfile,
}) => {
	const benefits =
		planProfile.numberOfInvestors === 0 ? (
			<NoMatching />
		) : (
			<MemberBenefits
				balanceAsOfDate={planProfile.planBalanceDate}
				planNumber={planProfile.planNumber}
				planName={planProfile.planName}
				planUUID={planUUID}
			/>
		);
	const transactions =
		planProfile.numberOfInvestors === 0 ? (
			<NoMatching />
		) : (
			<MemberTransactions
				balanceAsOfDate={planProfile.planBalanceDate}
				planNumber={planProfile.planNumber}
				planName={planProfile.planName}
				planUUID={planUUID}
			/>
		);

	return (
		<PlanProfileCard
			marginTop={6}
			data-id={planProfileTestIds.planProfileContainer}
		>
			<Tabs ariaLabel="Plan Profile">
				<TabsButtonGroup size="medium">
					<TabsButton>Plan Balance</TabsButton>
					<TabsButton>Plan Details</TabsButton>
					<TabsButton>Member Demographics</TabsButton>
					<TabsButton>Plan Investments</TabsButton>
					<TabsButton>Member Benefits</TabsButton>
					<TabsButton>Member Transactions</TabsButton>
				</TabsButtonGroup>
				<TabsContent>
					<PlanBalance
						balanceAsOfDate={planProfile.planBalanceDate}
						balance={planProfile.planBalance}
						expenseReserve={planProfile.expenseAmount}
						members={planProfile.policyCommitteeMembers}
					/>
				</TabsContent>
				<TabsContent>
					<PlanDetails
						planUUID={planUUID}
						planNumber={planProfile.planNumber}
						planName={planProfile.planName}
						productName={planProfile.productName}
					/>
				</TabsContent>
				<TabsContent>
					<MemberDemographics
						planUUID={planUUID}
						asAtDate={planProfile.planBalanceDate}
						totalInvestors={planProfile.numberOfInvestors}
					/>
				</TabsContent>
				<TabsContent>
					<PlanInvestments
						planUUID={planUUID}
						date={planProfile.planBalanceDate}
						investors={planProfile.numberOfInvestors}
					/>
				</TabsContent>
				<TabsContent>{benefits}</TabsContent>
				<TabsContent>{transactions}</TabsContent>
			</Tabs>
		</PlanProfileCard>
	);
};

export default PlanProfileTabs;
